export default __webpack_public_path__ + "static/media/kakaopay_logo.e6c23227.svg";